module.exports = __webpack_public_path__ + "img/chart-flowers-1-1x.b328c90f.png";